import React, {useContext, useState} from "react";
import {Button, CircularProgress, Stack, TextField} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {ArrowRight01Icon} from "@hugeicons/core-free-icons";
import {toast} from "react-toastify";
import {SignInContext} from "../../../context/SignInContext";
import {primaryButtonSx} from "../../landing/landingTokens";
import {AuthLayout} from "../components/AuthLayout";
import {fieldSx} from "../components/authStyles";

export const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const {onForgotPassword} = useContext(SignInContext);

  const loginHandle = async (e) => {
    e.preventDefault();

    const normalizedEmail = email.trim();
    if (!normalizedEmail) {
      toast.error("Please enter email address");
      return;
    }

    const toastId = toast.loading("Sending request for forgot password");
    try {
      setLoading(true);
      await onForgotPassword({email: normalizedEmail});
      toast.update(toastId, {
        type: "success",
        render: "Please check your email address",
        isLoading: false,
        autoClose: 2000,
      });
      setEmail("");
    } catch (err) {
      toast.update(toastId, {
        type: "error",
        render: err?.message || "Please try again later.",
        isLoading: false,
        autoClose: 2000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title={"Forgot password?"}
      prompt={"Remember your password?"}
      linkText={"Sign in"}
      linkTo={"/login"}
      preserveSearch={false}
    >
      <Stack component="form" onSubmit={loginHandle} direction="column" gap={0.5} sx={{width: "100%"}}>
        <TextField
          variant="filled"
          required
          fullWidth
          type="email"
          label="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="Enter your email address"
          helperText={" "}
          sx={fieldSx}
        />
        <Button
          fullWidth
          type="submit"
          disabled={loading || !email.trim()}
          sx={{...primaryButtonSx, py: 1.4, fontSize: 15, mt: 1}}
          endIcon={loading
            ? <CircularProgress size={16} color="inherit"/>
            : <HugeiconsIcon icon={ArrowRight01Icon} size={13}/>}>
          Send reset link
        </Button>
      </Stack>
    </AuthLayout>
  );
};
